<script>
	import Hero from './Hero.svelte';
	import Nav from './Nav.svelte';
	import Section from './Section.svelte';
	import { Find, About, Studies } from './sections';
</script>

<main>
	<Hero test="this is var" />
	<Nav />
	<Section id="section-find">
		<svelte:fragment slot="content">
			<Find />
		</svelte:fragment>
	</Section>
	<Section id="section-studies">
		<svelte:fragment slot="content">
			<Studies />
		</svelte:fragment>
	</Section>
	<Section id="section-about" marginBottom=150>
		<svelte:fragment slot="content">
			<About />
		</svelte:fragment>
	</Section>
</main>

<style lang="less">
	main {
		width: 100%;
		overflow-x: hidden;
	}
</style>